@if (dashboard) {
<!-- Welcome Header -->
<div class="dashboard-header m-b-24">
  <span class="header-date">{{ today | date:'EEEE, dd MMM yyyy' }}</span>
  <a (click)="loadDashboard()" matTooltip="Refresh DashBoard"><i-tabler name="refresh"
      class="icon-20 m-t-2"></i-tabler></a>
</div>

<!-- Row 1: Summary Cards -->
<div class="dashboard-grid">
  <!-- Appointments Card -->
  <mat-card class="summary-card card-appointments" (click)="navigateTo('/appointment')" *appHasRole="ROLE_GROUPS.AllTenant">
    <mat-card-content>
      <div class="card-top">
        <div class="card-icon icon-primary">
          <i-tabler name="calendar-event" class="icon-24"></i-tabler>
        </div>
        <div class="card-arrow">
          <i-tabler name="chevron-right" class="icon-18"></i-tabler>
        </div>
      </div>
      <h3 class="stat-number">{{ dashboard.totalAppointments }}</h3>
      <span class="stat-label">{{ 'LABEL.TOTAL_APPOINTMENTS' | translate }}</span>
      <div class="stat-badges m-t-12">
        <span class="badge badge-success">
          <i-tabler name="check" class="icon-14"></i-tabler> {{ dashboard.completedAppointments }}
        </span>
        <span class="badge badge-warning">
          <i-tabler name="clock" class="icon-14"></i-tabler> {{ dashboard.pendingAppointments }}
        </span>
        <!-- <span class="badge badge-error">
          <i-tabler name="x" class="icon-14"></i-tabler> {{ dashboard.cancelledAppointments }}
        </span> -->
      </div>
    </mat-card-content>
  </mat-card>


  <!-- Revenue Card -->
  <mat-card class="summary-card card-revenue" (click)="navigateTo('/reports/billing')" *appHasRole="ROLE_GROUPS.AllTenant">
    <mat-card-content>
      <div class="card-top">
        <div class="card-icon icon-success">
          <i-tabler name="currency-rupee" class="icon-24"></i-tabler>
        </div>
        <div class="card-arrow">
          <i-tabler name="chevron-right" class="icon-18"></i-tabler>
        </div>
      </div>
      <h3 class="stat-number">{{ dashboard.totalBilled | number:'1.0-0' }}</h3>
      <span class="stat-label">{{ 'LABEL.TODAYS_REVENUE' | translate }}</span>
      <div class="revenue-split m-t-12">
        <div class="revenue-item collected">
          <span class="revenue-dot"></span>
          {{ 'LABEL.COLLECTED' | translate }}: <strong>{{ dashboard.totalCollected | number:'1.0-0' }}</strong>
        </div>
        <div class="revenue-item outstanding">
          <span class="revenue-dot"></span>
          {{ 'LABEL.OUTSTANDING_LABEL' | translate }}: <strong>{{ dashboard.outstanding | number:'1.0-0' }}</strong>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <!-- Active IPD Card (conditional) -->
  @if (showIPD) {
  <mat-card class="summary-card card-ipd" (click)="navigateTo('/ipd/management')" *appHasRole="ROLE_GROUPS.AllTenant">
    <mat-card-content>
      <div class="card-top">
        <div class="card-icon icon-warning">
          <i-tabler name="bed" class="icon-24"></i-tabler>
        </div>
        <div class="card-arrow">
          <i-tabler name="chevron-right" class="icon-18"></i-tabler>
        </div>
      </div>
      <h3 class="stat-number">{{ dashboard.activeIPDCount }}</h3>
      <span class="stat-label">{{ 'LABEL.ACTIVE_IPD' | translate }}</span>
      <div class="bed-usage m-t-12">
        <mat-progress-bar mode="determinate" [value]="bedOccupancyPercent"
          [color]="bedOccupancyPercent > 80 ? 'warn' : 'primary'">
        </mat-progress-bar>
        <span class="bed-usage-text">{{ dashboard.occupiedBeds }}/{{ dashboard.totalBeds }} {{ 'LABEL.BEDS_USED' |
          translate }}</span>
      </div>
    </mat-card-content>
  </mat-card>
  }

    <!-- Pharmacy Card -->
  <mat-card *appHasRole="ROLE_GROUPS.Pharmacy" class="summary-card card-pharmacy" (click)="navigateTo('/pharmacy')">
    <mat-card-content>
      <div class="card-top">
        <div class="card-icon icon-accent">
          <i-tabler name="pill" class="icon-24"></i-tabler>
        </div>
        <div class="card-arrow">
          <i-tabler name="chevron-right" class="icon-18"></i-tabler>
        </div>
      </div>
      <h3 class="stat-number">{{ dashboard.totalPharmacySales | number:'1.0-0' }}</h3>
      <span class="stat-label">{{ 'LABEL.TODAY_MEDICINE_SALES' | translate }}</span>
      <div class="revenue-split m-t-12">
        <div class="revenue-item medicine-sales">
          <span class="revenue-dot"></span>
          {{ 'LABEL.TODAY_QTY_SOLD' | translate }}: <strong>{{ dashboard.totalPharmacySalesQuantity | number:'1.0-0' }}</strong>
        </div>
        <div class="revenue-item medicine-total-sales">
          <span class="revenue-dot"></span>
          {{ 'LABEL.TOTAL_MEDICINE_SALES' | translate }}: <strong>{{ dashboard.allTimePharmacySales | number:'1.0-0' }}</strong>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mat-card class="detail-card" *ngIf="dashboard.recentPatients && dashboard.recentPatients.length > 0">
  <mat-card-content>
    <div class="detail-card-header m-b-16">
      <h6 class="f-s-16 f-w-600 m-0">{{ 'LABEL.RECENT_PATIENTS' | translate }}</h6>
    </div>
    <div class="table-responsive">
      <table mat-table [dataSource]="dashboard.recentPatients" class="w-100 patients-table">
        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PATIENT_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="patient-name">{{ row.patientName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="patientNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PATIENT_NO' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="patient-number">{{ row.patientNumber }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastVisitDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.DATE' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.lastVisitDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="doctorName">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.DOCTOR' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.doctorName }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true" class="f-w-700"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer"
          (click)="viewPatientDetails(row.patientId)">
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
<!-- </div> -->
} @else {
<div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
  <mat-spinner diameter="40"></mat-spinner>
</div>
}
